export default __webpack_public_path__ + "static/media/564.b5f7362d.gif";